<template>
	<div class="plr-16 box-s" :class="{'pb-30': padShow }" id="nodes">
    <!-- 倒计时 -->
    <div class="flexs ps_clock">
      <img class="wh_14_17 mr-10" src="../../assets/img/icon/clock.png" alt="">
      <div class="c1 fz-16" >
        <span>倒计时</span> <span style="color: transparent">11</span>  <span :class="{ c9: time == '已超时' }">{{time}}</span>
      </div>
    </div>
    <div v-for="(item, index) in list" class="" :key="index">
      <!-- 头部题型和题数 -->
      <div :class="{ 'pt-66': item.is_stuff_question }" v-if="qusetNum == (index + 1)">
          <div class="quest_header flexs h66 bg_f" :class="{ 'ps_top': item.is_stuff_question, 'plr-16': item.is_stuff_question }">
            <div class="c1 fz-16 mb-6"> <span class="fz-28 fw-500">{{qusetNum}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>
            <template v-if="!item.is_stuff_question">
              <div v-if="item.question_type == 1" class="tag_class ml-5 bg_ff c13">单选题</div>
              <div v-if="item.question_type == 2" class="tag_class ml-5 bg_dc c12">多选题</div>
              <div v-if="item.question_type == 3" class="tag_class ml-5 bg_ea c11">判断题</div>
              <div v-if="item.question_type == 5" class="tag_class ml-5 bg_d8 c0">填空题</div>
              <div v-if="item.question_type == 4" class="tag_class ml-5 bg_d8 c0">简答题</div>
            </template>
            <div v-else class="tag_class ml-5 bg_bb c16">材料题</div>
          </div>
        </div>
       
      <div v-if="item.is_stuff_question && qusetNum == (index + 1)" class="pt-155">
        <div class="mb-22 box_shaw_6 ps_top top66 plr-16 bg_f box-s">
          <div class="over-auto cail trans" :ref="'DOM' + index" :style="{ 'height': cheight + 'px' }">
            <div class="fz-14 fw-500 c1"  v-html="item.material"></div>
          </div>
          <div class="flexs flex-center box-s c0 fz-12 fw-500 l-h-40" @click="showHe">
            <div class="flexs flex-center l-h-40" v-if="showFlag">
              <div>{{txtflag? '收起': '展开'}}</div>
              <span v-if="!txtflag" class="iconfont icon-arrow-down fz-10 ml-7"></span>
              <span v-else class="iconfont icon-shangjiantou fz-10 ml-7"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="qusetNum == (index + 1)" class="fz-14 fw-500 c1 mb-22" v-html="item.question_stem"></div>


      <!-- 单选题 -->
      <ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 1)">
        <li class="flexs mb-22 pd-20-16  b-radius-6 bg_f8 box-s flex-jus bb-ff" :class="{ 'tag_active': form.answer[qusetNum - 1].answer[0] == Object.keys(innerItem)[0] }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex" @click="getPageQuest(item.question_type,Object.keys(innerItem)[0] )">
          <div class="flexs">
            <div class="">{{Object.keys(innerItem)[0]}}.</div>
            <div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
          </div>
        </li>
      </ul>

      <!-- 判断题 -->
      <ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 3)">
        <li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 box-s bb-ff" :class="{ 'tag_active': form.answer[qusetNum - 1].answer === 'true' }" @click="getPageQuest(item.question_type,'true' )">
          <div class="flexs">
            <div class="">A.</div>
            <div class="ml-6" >正确</div>
          </div>
        </li>

        <li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 box-s bb-ff" :class="{ 'tag_active': form.answer[qusetNum - 1].answer === 'false' }" @click="getPageQuest(item.question_type,'false' )">
          <div class="flexs">
            <div class="">B.</div>
            <div class="ml-6" >错误</div>
          </div>
        </li>
        
      </ul>
      

      <!-- 多选题 -->
      <ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 2)">
        <li class="flexs flex-jus mb-22 pd-20-16  b-radius-6 bg_f8 box-s bb-ff" :class="{ 'tag_active': form.answer[qusetNum - 1].answer.indexOf(Object.keys(innerItem)[0]) != -1 }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex" @click="getPageQuest(item.question_type,Object.keys(innerItem)[0])">
          <div class="flexs">
            <div class="">{{Object.keys(innerItem)[0]}}.</div>
            <div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
          </div>
        </li>
      </ul>

      <!-- 填空题/简答题 -->
      <div v-if="qusetNum == (index + 1) && (item.question_type == 4 || item.question_type == 5)">
        <div  class="textarea_box mb-12">
          <textarea v-model="form.answer[qusetNum - 1].answer" class="textarea" name="" id="" cols="30" rows="10" placeholder="请输入答案"></textarea>
        </div>

        <div class="mb-22">
          <addImg :imgList="form.answer[qusetNum - 1].imgList" @addImg="addImg" @delImg="delImg"/>
        </div>
      </div>

    </div>
		<loading :loadFlag="loadFlag"></loading>
    <qusetBottom :questBtn="questBtn" :length="length" :cData="cData" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" ></qusetBottom>
	</div>
</template>
<script>
	import loading from "@/components/loading"
	import { dryRunMatchQuestion, dryRunMatchSubmit } from '@/api/api.js'
	import {getShowPadding, clear} from "@/utils/common.js";
	import qusetBottom from "@/components/qusetBottom.vue";
	import addImg from "@/components/addImg.vue";
	export default {
		components: {
      qusetBottom,
			addImg,
      loading
		},
		data() {
			return {
        loadFlag: false,
        length: 0,
        number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],//题目前序号
				collectFalg: false, //是否收藏
        list: [], //题数据
				qusetNum: 1, //第几道题
				padShow: false, //是否展示底部30padding
        cData: {
          question_id: '',
          model_type: 8,
          way: 2, 
          base_id: ''
        },
				// question_type: 0, // 题的类型 1-单选 2-多选 3-判断 4-简答 5-填空 6-材料

				form: {  //提交数据
          test_paper_id: '',
          start_time: '',
          answer: []
        }, 
        time: '',
				showHeader: false, //材料题头部动画
				hideHeader: false,//材料题头部动画
				flag: false,//材料题头部动画
				txtflag: false,//材料题头部动画
				timeflag: false,//材料题头部动画
        questBtn: true,
        cheight: '',
				commonHeight: '',
				showFlag: false

			};
		},
		created() {
      this.qusetNum = this.$route.query.qusetNum? Number(this.$route.query.qusetNum) : 1
      this.cData.base_id = this.$route.query.test_paper_id
      this.downTime()
      this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		methods: {
      init(){
        this.showHeader = false
        this.flag = false
        this.txtflag = false
        this.timeflag = false
        this.collectFalg = true
			},
      async initData(){
        this.loadFlag = true
        const res = await dryRunMatchQuestion({ test_paper_id: this.$route.query.test_paper_id })
        this.loadFlag = false
        if( res.code == 1000 ){
          this.list = res.data
          this.length = this.list.length
          this.collectFalg = this.list[this.qusetNum - 1].collect == 1
          this.getCliao()
          if(!this.$route.query.form){
            this.form.test_paper_id = this.$route.query.test_paper_id
            this.form.start_time = new Date().getTime()
            this.form.answer = this.list.map(item => {
            return { 
              question_id:  item.id,
              answer:  item.question_type == 1 || item.question_type == 2? []: "",
              picture: '',
              imgList: [],
              imgId: []
             }
          })
          } else {
            this.form = JSON.parse(this.$route.query.form)
          }
          console.log(this.form, 'form')
          this.cData.question_id = this.list[this.qusetNum - 1].id
        } else {
          this.$toast(res.msg)
        }
			},
      getCliao(){
				this.cheight = ''
				this.commonHeight = ''
				this.showHeader = false
				this.txtflag = false
        if(this.list[this.qusetNum - 1].is_stuff_question){
					this.$nextTick(()=>{
						const r = document.documentElement.clientWidth / 375
						this.commonHeight = this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].offsetHeight * r:this.$refs['DOM'+ (this.qusetNum - 1)].offsetHeight
						this.cheight = 98 * r
						this.showFlag = this.commonHeight > this.cheight
						console.log(1111, this.commonHeight, this.cheight,this.$refs['DOM'+ (this.qusetNum - 1)][0])
					})
				}
			},
      
      // 倒计时
      downTime () {
        let time = '';
        if(this.$route.query.time_limit){
          time = this.$route.query.time_limit * 60
          localStorage.getItem('timer') && clearInterval(localStorage.getItem('timer'))
          localStorage.getItem('timer') && localStorage.removeItem('timer')
          localStorage.getItem('time') && localStorage.removeItem('time')
          
        } else {
          time = Number(localStorage.getItem('time'))
        }
        if(this.$route.query.time_limit == 0 || localStorage.getItem('time') == 0){
          this.time = '已超时'
          this.getSubmit()
          return
        }
          
        this.getTime(time)
        
        this.timer = setInterval(()=>{
          
          time = time - 1
          localStorage.setItem('time', time)
          if(time == 0 || time < 0){
            this.time = '已超时'
            this.getSubmit()
            clearInterval(this.timer)
            localStorage.removeItem('time')
            localStorage.removeItem('timer')
            return
          }
          this.getTime(time)
          
        }, 1000)
        localStorage.setItem('timer', this.timer)
      },
      
      // 倒计时
      getTime(time){
        let hour = parseInt(time / 60 / 60)
        let min = parseInt((time - hour * 60 * 60) / 60) 
        let sec = parseInt(time - hour * 60 * 60 - min * 60)
        this.time = (hour == 0? "": ((hour<10? '0' + hour:hour) + ':')) + (min<10?'0'+min:min) + ":" + (sec<10?'0'+sec:sec)
        return sec
      },
      

      
      // 提交答案
      getSubmit(){
        this.$toast.loading({
          duration: 1000,
          forbidClick: true,
          message: '时间已到，正在交卷',
        });

        setTimeout(async ()=>{
          const { answer, start_time, test_paper_id } = this.form
          const arr = answer.map(item => {
            return { question_id: item.question_id, picture: item.imgId.length == 0? '': (item.imgId.length == 1? `${ item.imgId }` : item.imgId.join(',')), answer: item.answer }
          })

          const res = await dryRunMatchSubmit({ start_time, test_paper_id, answer: JSON.stringify(arr)  })
          this.$toast.clear();
          if( res.code == 1000 ){
            this.$toast.success('答题完成')
            clear()
            setTimeout(()=>{
              this.$router.replace({ path: '/midereport', query: { answer_id: res.data.answer_id } })
            }, 1000)
          } else {
            this.$toast(res.msg)
          }
        }, 1000)
        
      },
      


			// 上一页，下一页
			getQuest(type){
        this.init()
        if(type == '1'){
          this.qusetNum -= 1
        } else if (type == '2') {
          this.qusetNum += 1
        }
        this.getCliao()
        this.cData.question_id = this.list[this.qusetNum - 1].id
        this.collectFalg = this.list[this.qusetNum - 1].collect == 1
				
			},

      // 单选多选判断切换
      getPageQuest(type, item){
        console.log(type,item,888)
        if(type == 1){
          this.form.answer[this.qusetNum - 1].answer = [item]
        } else if(type == 2){
          if(this.form.answer[this.qusetNum - 1].answer.indexOf(item) == -1){
            this.form.answer[this.qusetNum - 1].answer.push(item)
          } else {
            this.form.answer[this.qusetNum - 1].answer.splice(this.form.answer[this.qusetNum - 1].answer.indexOf(item), 1)
          }
        } else {
          this.form.answer[this.qusetNum - 1].answer = item
        }
      },

      // 添加图片
      addImg(data){
        this.form.answer[this.qusetNum - 1].imgList.unshift(data.path)
        this.form.answer[this.qusetNum - 1].imgId.unshift(data.id)
      },

      // 删除图片
      delImg(data){
         this.form.answer[this.qusetNum - 1].imgList.splice(data, 1)
        this.form.answer[this.qusetNum - 1].imgId.splice(data, 1)
      },

			// 收藏
			collect(collectFalg){
				!collectFalg && this.$toast('已收藏至错题本')
        this.collectFalg = !collectFalg
        this.list[this.qusetNum - 1].collect = !collectFalg? 1: 0
			},

			// 查看答题卡
			quertCard(){
				const form = JSON.stringify(this.form)
        this.$router.replace({path: '/midecard', query:{form, test_paper_id: this.$route.query.test_paper_id } })
			},
      
			// 材料题展开收起
			showHe(){
				  if(!this.showFlag) return
          if(!this.showHeader){
            const h = document.documentElement.clientHeight * (document.documentElement.clientWidth / 375) * 0.55
						this.cheight = this.commonHeight > h ? h : this.commonHeight
					} else {
						this.cheight = 98 * (document.documentElement.clientWidth / 375)
						this.$nextTick(() => {
								this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].scrollTo(0,0): this.$refs['DOM'+ (this.qusetNum - 1)].scrollTo(0,0);
						})
					}
					
          this.showHeader = !this.showHeader
					this.txtflag = this.showHeader
				
        
			}
		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}

.animal {
	animation: show 1s;
	animation-fill-mode:forwards;
}

@keyframes show {
	0% {
		display: none;
	}
	100% {
		display: block;
	}
}

.h100px {
  height: 98px;
	transition: all 1s;
}
.heightamimal {
	overflow: auto;
	height: 50vh;
}
.heightamimal::-webkit-scrollbar {
  display: none;
}

</style>
